import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend,
} from 'recharts';

const MonthlyTransactionChart = ({ month }: { month: string }) => {
  const [data, setData] = useState<{ value: number }[]>([]);
  const API = process.env.REACT_APP_API_URL;

  const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
    };
  };

  useEffect(() => {
    axios
      .get(`${API}/analytics/monthly-transactions?month=${month}`, getAuthHeader())
      .then((res) => setData([{ value: res.data.value }]))
      .catch((err) => console.error('❌ Failed to fetch monthly transactions', err));
  }, [month]);

  const label = new Date(`${month}-01`).toLocaleDateString("id-ID", {
    month: "long",
    year: "numeric",
  });

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={() => label} 
		  tick={{ fontSize: 13 }} // ✅ kecilkan font label
		/>
        <YAxis tickFormatter={(v: number) => `${v / 1_000_000}M`} 
		  tick={{ fontSize: 13 }}
		/>
        <Tooltip formatter={(value: number) => new Intl.NumberFormat().format(value)} />
        <Legend />
        <Bar dataKey="value" fill="#4f46e5" name="Total Transaksi" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MonthlyTransactionChart;
